var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Automotive custom widgets — cluster.
 */
import { registerAutomotive, createAutomotiveFromJSON } from '../../registryCore';
import { bool, createAutoGroup, num, setState, str, } from '../../helpers';
import { autoThemeName, themeFromProps } from '../../themes';
import { resolveClusterLayout } from '../../layout';
function buildInstrumentCluster(props, app, type) {
    var e_1, _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var theme = themeFromProps(props);
    var w = num(props, 'width', 800);
    var h = num(props, 'height', 400);
    var incomingCall = bool(props, 'incomingCall', false) || bool(props, 'showCall', false);
    var group = createAutoGroup(app, type, props, type, { width: w, height: h });
    group.add(app.rect({
        width: w,
        height: h,
        fill: theme.background,
        cornerRadius: Math.min(16, h * 0.04),
        stroke: theme.dialStroke,
        strokeWidth: 2,
        listening: false,
    }));
    var themeName = autoThemeName(props);
    var isDigital = themeName === 'digital';
    var gaugeDisplay = isDigital ? 'digital' : 'analog';
    var valueByType = {
        speedometer: { value: (_b = props.speed) !== null && _b !== void 0 ? _b : 0, display: gaugeDisplay },
        tachometer: { value: (_c = props.rpm) !== null && _c !== void 0 ? _c : 0, display: gaugeDisplay },
        gearIndicator: { gear: (_d = props.gear) !== null && _d !== void 0 ? _d : 'P' },
        engineTemp: { value: (_e = props.engineTemp) !== null && _e !== void 0 ? _e : 90, display: gaugeDisplay },
        turnIndicators: { left: (_f = props.turnLeft) !== null && _f !== void 0 ? _f : false, right: (_g = props.turnRight) !== null && _g !== void 0 ? _g : false },
        fuelGauge: { value: (_h = props.fuel) !== null && _h !== void 0 ? _h : 75 },
        batteryVoltage: { value: (_j = props.batteryVoltage) !== null && _j !== void 0 ? _j : 12.4 },
        tpms: { pressures: (_k = props.tpms) !== null && _k !== void 0 ? _k : [32, 32, 32, 32] },
        parkingBrake: { active: (_l = props.parkingBrake) !== null && _l !== void 0 ? _l : false },
        headlights: { active: (_m = props.headlights) !== null && _m !== void 0 ? _m : false },
        cruiseControl: { speed: (_o = props.cruiseSpeed) !== null && _o !== void 0 ? _o : 0 },
        warningLamp: { label: 'ABS', active: (_p = props.absWarning) !== null && _p !== void 0 ? _p : false },
        adasStatus: { status: (_q = props.adasStatus) !== null && _q !== void 0 ? _q : 'off' },
        callScreen: {
            caller: str(props, 'caller', 'Alex Morgan'),
            subtitle: str(props, 'subtitle', str(props, 'phone', 'Mobile')),
            status: str(props, 'callStatus', str(props, 'status', 'incoming')),
            hint: str(props, 'callHint', str(props, 'hint', 'Swipe to answer')),
            lines: (_r = props.lines) !== null && _r !== void 0 ? _r : ['Incoming…', 'Swipe to answer'],
        },
    };
    try {
        for (var _s = __values(resolveClusterLayout(w, h, { callScreen: incomingCall })), _t = _s.next(); !_t.done; _t = _s.next()) {
            var slot = _t.value;
            var wt = slot.type, size = slot.size, slotW = slot.width, slotH = slot.height, slotX = slot.x, slotY = slot.y;
            var slotDigital = gaugeDisplay === 'digital' || slotW < 128 || slotH < 80 || (size !== undefined && size < 96);
            var node = createAutomotiveFromJSON(wt, __assign(__assign(__assign({ x: 0, y: 0, width: slotW, height: slotH }, (size !== undefined ? { size: Math.min(size, Math.min(slotW, slotH) - 4) } : {})), valueByType[wt]), { theme: themeName, display: wt === 'speedometer' || wt === 'tachometer' || wt === 'engineTemp'
                    ? slotDigital ? 'digital' : gaugeDisplay
                    : undefined }), app);
            if (node) {
                var slotWrap = app.group({
                    x: slotX,
                    y: slotY,
                    clip: true,
                    metadata: {
                        autoSlot: wt,
                        autoState: { width: slotW, height: slotH },
                        autoWidth: slotW,
                        autoHeight: slotH,
                    },
                });
                slotWrap.add(node);
                group.add(slotWrap);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_t && !_t.done && (_a = _s.return)) _a.call(_s);
        }
        finally { if (e_1) throw e_1.error; }
    }
    setState(group, __assign({ width: w, height: h, theme: themeName }, props));
    return group;
}
registerAutomotive('instrumentCluster', function (props, app) { return buildInstrumentCluster(props, app, 'instrumentCluster'); });
registerAutomotive('digitalInstrumentCluster', function (props, app) { var _a; return buildInstrumentCluster(__assign(__assign({}, props), { theme: (_a = props.theme) !== null && _a !== void 0 ? _a : 'digital' }), app, 'digitalInstrumentCluster'); });
